import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import BaseVue from '~/nasa_ui/base/BaseVue';
import { CosmicEnvironment } from '~/nasa_ui/types/cosmic/environments';
let TheEnvironmentCallout = class TheEnvironmentCallout extends Mixins(BaseVue) {
    get cosmicEnvironment() {
        return this.$cosmicEnvironment;
    }
    get isDevelopment() {
        return this.$cosmicEnvironment === CosmicEnvironment.DEVELOPMENT;
    }
    get isLocal() {
        return this.cosmicEnvironment === CosmicEnvironment.LOCAL;
    }
    get isStaging() {
        return this.cosmicEnvironment === CosmicEnvironment.STAGING;
    }
};
TheEnvironmentCallout = __decorate([
    Component
], TheEnvironmentCallout);
export default TheEnvironmentCallout;
